import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../styles/app.css';
import { registerServiceWorker } from '../pwa/registerServiceWorker';
import { App } from './App';
import { ErrorBoundary } from './ErrorBoundary';
import { installTestHooks } from './testHooks';

/**
 * Application bootstrap: mount, install global error handling, register the service worker.
 */

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Root container is missing from index.html');
}

// Errors escaping React are logged in development and swallowed in production, where the
// error boundary and per-feature fallbacks already keep the game usable.
globalThis.addEventListener('error', (event) => {
  if (import.meta.env.DEV) console.error('Uncaught error', event.error);
});
globalThis.addEventListener('unhandledrejection', (event) => {
  if (import.meta.env.DEV) console.error('Unhandled rejection', event.reason);
});

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

registerServiceWorker();
installTestHooks();
